import { MOVE_ROW_BENEFICIARY_STATUS } from '@/modules/move/entities/enums/move';
import { ExportMoveRowsFilters, CountMoveRowFilters } from '@/modules/move/entities/interfaces/moveRow';
import HttpClientAdapter from '@/shared/services/httpClientAdapter';

export class MoveRowService extends HttpClientAdapter {
  constructor() {
    super('MONITORING');
  }

  getCountRowsByBeneficiaryStatus(filters: CountMoveRowFilters) {
    return this.get<Record<MOVE_ROW_BENEFICIARY_STATUS, number>>(
      '/rows/count-rows-by-beneficiary-status',
      filters,
    );
  }

  exportRows(filters: Partial<ExportMoveRowsFilters>) {
    return this.get<Blob>('/rows/export', filters, {
      responseType: 'blob',
    });
  }
}
